// extracted by mini-css-extract-plugin
module.exports = {"numberOfResults":"az_xPc","withMargin":"az_yPc","countAndTotal":"az_zPc","smallText":"az_APc","shareLinkButtonWrapper":"az_BPc","sharableLink":"az_CPc","button":"az_DPc"};